import { Route, Routes } from 'react-router-dom';

export default function RoutesWithNotFound(props) {
  return (
    <Routes>
      {props.children}
      <Route path="*" element={<div>Not Found</div>} />
    </Routes>
  );
}
